import {ObjectProperties} from './communicationProperties';
import {QueryableProperty} from '../queryableProperty';

export class PostProperties extends ObjectProperties {
  constructor() {
    super();
    this.properties = [
      new QueryableProperty('id', 'Id', 'customer', false),
      new QueryableProperty('title', 'Title', 'string', false),
    ];
    this.sortingPropertyName = 'lexorank';
    this.sortingDescending = true;
  }
}
